import Dialog from 'global/guides/Dialog'
import { useLocaisOutletContext } from 'pages/Locais.context'
import { useParams } from 'react-router-dom'
import { AssociarFuncionarioForm } from '../atoms/AssociarFuncionarioForm'

export default function AssociarLocal() {
    const { id } = useParams()
    const { data } = useLocaisOutletContext()
    const l = data?.find(item => item.id === Number(id))

    if (!l) return null

    return (
        <Dialog.Root defaultValues={l}>
            <Dialog.Title>
                Associar funcionários ao local {l.nomeLocal}
            </Dialog.Title>
            <Dialog.Content>
                <AssociarFuncionarioForm />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton>
                    Fechar
                </Dialog.Actions.SecondaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
